import __request__ from "routing/request";
export function getAwsRegions(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.archive/backends/s3/regions", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
